<template>
  <div>
    <v-container>
      <v-card>
        <v-card-text style="padding: 0px">
          <template>
            <v-toolbar color="primary" light>
              <v-toolbar-title class="white--text">Coupons</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items class="hidden-sm-and-down">
                <v-btn color="white" flat @click="addCoupon()" :disabled="!vid"
                  >Add New</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
          </template></v-card-text
        ></v-card
      ></v-container
    >
    <v-container>
      <v-toolbar flat color="white" dense style="margin-bottom:0px">
        <v-btn color="success" small @click="loadCoupons()"
          ><v-icon>mdi-refresh</v-icon> Refresh</v-btn
        >
        <v-btn
          color="danger"
          class="white--text"
          small
          @click="confirm = true"
          :disabled="!selected.length > 0"
          ><v-icon>mdi-delete</v-icon> Delete</v-btn
        >
        <v-btn
          color="primary"
          small
          @click="editCoupon()"
          :disabled="!(selected.length == 1)"
          ><v-icon>mdi-lead-pencil</v-icon> Edit</v-btn
        >
        <v-spacer></v-spacer>
        <div style="width:200px;">
          <v-text-field
            v-model="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </div>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="coupons"
        :search="search"
        :loading="true"
        item-key="id"
        select-all
        v-model="selected"
        dense
        class="elevation-1"
      >
        <v-progress-linear
          slot="progress"
          color="blue"
          indeterminate
        ></v-progress-linear>
        <template slot="headerCell" slot-scope="{ header }">
          <div
            class="subheading font-weight-light text-primary text--darken-3"
            v-text="header.text"
          ></div>
          <div
            class="font-weight-light text--darken-4"
            v-text="header.desc"
          ></div>
        </template>

        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              v-model="props.selected"
              color="primary"
              hide-details
            ></v-checkbox>
          </td>
          <td>
            {{ props.index }}
          </td>
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">
            <v-icon small>mdi-currency-inr</v-icon
            >{{ props.item.min_order_amount }}
          </td>
          <td>
            <span v-if="props.item.type == 'f'">flat</span>
            <span v-else-if="props.item.type == '%'">percentage</span
            ><span v-else>free shipping</span>
          </td>
          <td class="text-xs-right">
            <span v-if="props.item.type == 'f'"
              ><v-icon small>mdi-currency-inr</v-icon
              >{{ props.item.amount }}</span
            >
            <span v-else-if="props.item.type == '%'"
              >{{ props.item.amount }}%</span
            ><span v-else></span>
          </td>
          <td class="text-xs-right">{{ props.item.count }}</td>
          <td class="text-xs-right">{{ props.item.limit }}</td>
          <td class="text-xs-center text-md-center">
            <v-switch
              v-model="props.item.active"
              color="primary"
              class="v-input--reverse"
              style="justify-content:center;"
              hide-details
              @change="updateActive(props.item.id, props.item.active)"
            >
              <template slot="label">
                Active
              </template>
            </v-switch>
          </td>
          <td>{{ dateFormatted(props.item.expiry) }}</td>
        </template>
      </v-data-table>

      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card>
          <v-card-title class="pb-0">
            <span v-if="mode == 'add'" class="headline">New Coupon</span>
            <span v-else class="headline">Update Coupon</span>
          </v-card-title>
          <v-card-text class="pt-0">
            <v-form v-model="valid">
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Coupon Code*"
                    :rules="rules.required"
                    v-model="coupon.code"
                  ></v-text-field>
                  <v-text-field
                    label="Minimum order amount*"
                    type="number"
                    v-model.number="coupon.min_order_amount"
                  ></v-text-field>
                  <v-select
                    v-model="coupon.type"
                    :items="operations"
                    item-text="name"
                    item-value="value"
                    label="Discount Type*"
                    dense
                  >
                  </v-select>
                  <v-text-field
                    label="Discount amount/percentage*"
                    type="number"
                    v-model.number="coupon.amount"
                  ></v-text-field>
                  <v-text-field
                    label="Count*"
                    type="number"
                    hint="Maximum count of vouchers. enter 0 for no limit"
                    v-model.number="coupon.count"
                  ></v-text-field>
                  <v-text-field
                    label="Limit*"
                    type="number"
                    hint="Limit of uses per user. enter 0 for no limit"
                    v-model.number="coupon.limit"
                  ></v-text-field>
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template slot="activator" scope="{ on }">
                      <v-text-field
                        :value="dateFormatted(coupon.expiry)"
                        label="Expiry"
                        hint="MM/DD/YYYY format"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="coupon.expiry"
                      no-title
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                  <v-switch
                    v-model="coupon.active"
                    color="primary"
                    class="v-input--reverse"
                    hide-details
                  >
                    <template slot="label">
                      Active
                    </template>
                  </v-switch>
                </v-flex>
              </v-layout>
            </v-form>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              small
              outline
              @click.native="
                dialog = false;
                resetForm();
              "
              >Close</v-btn
            >
            <v-btn
              v-if="mode == 'add'"
              color="primary darken-1 white--text"
              small
              :disabled="!valid"
              @click.native="insertCoupon()"
              >Save</v-btn
            >
            <v-btn
              v-else
              color="primary darken-1 white--text"
              small
              :disabled="!valid"
              @click.native="updateCoupon()"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog2" max-width="400px">
        <v-card>
          <v-card-title class="red--text">
            <h3>Warning !!</h3>
          </v-card-title>
          <v-card-text>
            Error:
            {{ error ? error : 'Something went wrong... Please try again.' }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn
              color="blue"
              flat
              @click="
                dialog2 = false;
                error = '';
              "
              >close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="confirm" width="400">
        <v-card style="width:100%;">
          <v-card-title class="red--text">
            Warning !!
          </v-card-title>
          <v-card-text class="pt-0">
            Do you really want to delete this coupon?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small color="primary" dark outline @click="confirm = false"
              >Cancel</v-btn
            >
            <v-btn small dark color="primary" @click="deleteCoupon()"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script type="text/javascript">
import api from '@/api';
export default {
  data() {
    return {
      search: '',
      uploading: false,
      progress: 0,
      mode: 'add',
      menu1: false,
      selected: [],
      coupons: [],
      headers: [],
      deletedId: '',
      dialog: false,
      coupon: {
        code: '',
        type: '',
        active: true,
        count: 0,
        limit: 0,
        min_order_amount: 0,
        amount: 0,
        expiry: '',
      },
      rules: {
        required: [v => /^(?!\s*$).+/.test(v) || 'Field is required'],
        digits: [
          v => /^(?!\s*$).+/.test(v) || 'Field is required',
          v => /^[0-9]*$/.test(v) || 'Please enter digits only.',
        ],
      },
      dialog: false,
      dialog2: false,
      error: '',
      dialog1: false,
      valid: false,
      valid1: false,
      confirm: false,
      operations: [
        {
          name: 'flat',
          value: 'f',
        },
        {
          name: 'percentage',
          value: 'p',
        },
        {
          name: 'free shipping',
          value: 's',
        },
      ],
    };
  },
  watch: {
    vid() {
      this.loadCoupons();
    },
  },
  computed: {
    vid() {
      return this.$store.state.vid;
    },
  },
  methods: {
    loadCoupons() {
      let loader = this.$loading.show();
      api
        .get('coupons/')
        .then(r => {
          this.coupons = r.data;
          loader.hide();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.loadCoupons();
            }
          }
        });
    },
    addCoupon() {
      this.mode = 'add';
      this.dialog = true;
    },
    updateActive(id, v) {
      let loader = this.$loading.show();
      api
        .put('coupons/' + id, { active: v })
        .then(r => {
          loader.hide();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.updateActive(id, v);
            }
          }
        });
    },
    insertCoupon() {
      if (this.valid) {
        let loader = this.$loading.show();
        api
          .post('coupons', this.coupon)
          .then(r => {
            loader.hide();
            this.loadCoupons();
            this.resetForm();
            this.dialog = false;
          })
          .catch(err => {
            loader.hide();
            this.dialog2 = true;
            this.error = err.response.data.message;
          });
      }
    },
    dateFormatted(date) {
      if (!date) return null;

      return new Date(date).toLocaleDateString();
    },
    editCoupon() {
      this.coupon = this.selected[0];
      this.valid = false;
      this.coupon.expiry = new Date(this.coupon.expiry)
        .toISOString()
        .substr(0, 10);
      this.dialog = true;
      this.mode = 'edit';
    },
    updateCoupon() {
      if (this.valid) {
        let loader = this.$loading.show();
        var This = this;
        api
          .put('coupons/' + this.coupon.id, this.coupon)
          .then(r => {
            loader.hide();
            this.loadCoupons();
            this.resetForm();
            this.dialog = false;
            this.selected = [];
          })
          .catch(err => {
            loader.hide();
            this.dialog2 = true;
          });
      }
    },
    deleteCoupon() {
      this.confirm = false;
      let loader = this.$loading.show();
      let id = this.selected[0].id;
      api
        .delete('coupons/' + id)
        .then(r => {
          loader.hide();

          this.loadCoupons();
          this.selected = [];
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.deleteCoupon();
            }
          }
        });
    },
    resetForm() {
      this.coupon = {
        code: '',
        type: '',
        active: true,
        count: 0,
        limit: 0,
        min_order_amount: 0,
        amount: 0,
        expiry: '',
      };
      this.valid = false;
    },
  },
  created() {
    if (this.vid) this.loadCoupons();
    this.headers = [
      {
        sortable: false,
        text: 'Sr. No.',
        value: 'srNo',
      },
      {
        sortable: false,
        text: 'Voucher Code',
        value: 'code',
      },
      {
        sortable: false,
        text: 'Minimum Order Amount',
        value: 'min_order_amount',
      },
      {
        sortable: false,
        text: 'Discount Type',
        value: 'type',
      },
      {
        sortable: false,
        text: 'Amount/Percentage',
        value: 'amount',
      },
      {
        sortable: false,
        text: 'Count',
        value: 'count',
      },
      {
        sortable: false,
        text: 'Limit per user',
        value: 'limit',
      },
      {
        sortable: false,
        text: 'Active',
        value: 'active',
      },
      {
        sortable: false,
        text: 'Expiry',
        value: 'expiry',
      },
    ];
  },
};
</script>
